import React from 'react';
import PropTypes from 'prop-types';
import MineralUIPagination from 'mineral-ui/Pagination';

const propTypes = {
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
};

export default function Pagination({
  currentPage,
  onPageChange,
  pageSize,
  totalCount,
}) {
  return (
    <MineralUIPagination
      currentPage={currentPage}
      onPageChange={onPageChange}
      pageSize={pageSize}
      totalCount={totalCount}
    />
  );
}
Pagination.propTypes = propTypes;
